import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.domain.autorenew;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_AUTORENEW',
	method: 'POST',
	url: '/network/dns/domain/autorenew.json',
});

export { actions, reducer, sagas, selectors };
